export enum FormMode {
    ADD = "ADD",
    EDIT = "EDIT",
    VIEW = "VIEW",
}